import * as React from 'react';
import { clsx } from 'clsx';

import styles from './LinkArea.css';

interface ILinkAreaProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  href: string;
  rel: string;
  preventDefault?: boolean;
  target?: React.HTMLAttributeAnchorTarget;
}

export function LinkArea({ href, rel, children, preventDefault, target, ...divProps }: ILinkAreaProps) {
  const onLinkClick = React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (preventDefault) {
        e.preventDefault();
      }
    },
    [preventDefault],
  );

  return (
    <div {...divProps} className={clsx(styles['container'], divProps.className)}>
      <a href={href} rel={rel} className={styles['link']} onClick={onLinkClick} target={target}>
        <span className={styles['link-area']} />
      </a>
      {children}
    </div>
  );
}
